<template>
  <h1 class="title is-h1">
    <slot />
  </h1>
</template>

<script>
export default {
  name: 'RsH1'
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';

h1 {
  color: var(--gray-900);
  font-size: $h1-headline;
  line-height: $lh-h1-headline;
  font-weight: $font-bold;

  @media (max-width: 768px) {
  }
}
</style>
